import moment from 'moment'
import Dexie from 'dexie'
import * as log from 'loglevel'
import { Subject } from 'rxjs'

const DB_NAME = 'swarm'
const db = new Dexie(DB_NAME)

/**
 * Migration
 */
db.version(1).stores({
  chunks: 'id,chunk',
  pages: 'id,page'
})

db.version(1.1).stores({
  chunks: 'id,chunk',
  pages: 'id,page',
  notifications: 'id, userId, message, title, type, createdAt, redirect'
})

db.version(1.2).stores({
  chunks: 'id,chunk',
  pages: 'id,page',
  notifications:
    'id, userId, message, title, eventType, createdAt, eventUser, redirect'
}).upgrade(trans => {
  log.info('Start indexed database migration.')
  return trans.notifications.toCollection().modify((notification, ref) => {
    if (!notification.eventType) {
      delete ref.value
    }
    const eventUser = Object.assign({}, notification.user)
    notification.eventUser = eventUser
    delete notification.user
    delete notification.type
  })
})

/**
 * Open connection
 */
db.open()

/**
 * Ready event observable
 */
const onReady$ = new Subject()
db.on('ready', () => onReady$.next())

const handleError = e => {
  return new Promise((resolve, reject) => {
    if (e instanceof Dexie.InvalidStateError) {
      const subscription = onReady$.subscribe(() => {
        subscription.unsubscribe()
        resolve()
      })
      db.open()
    } else {
      reject(e)
    }
  })
}
const insertNotifications = async data => {
  const { userId, message, id } = data
  const { content, createdAt, events, title } = message
  const { payload, eventType } = events[0]
  const { user } = payload
  const pageId = payload.chunk.root ? payload.chunk.root.id : payload.chunk.id
  const redirect = {
    name: 'problemPage',
    params: {
      id: pageId
    }
  }
  const record = {
    createdAt: moment(createdAt).valueOf(),
    id,
    message: content,
    redirect,
    title,
    eventType,
    eventUser: user,
    userId
  }
  try {
    await db.notifications.put(record)
  } catch (e) {
    await handleError(e)
    await db.notifications.put(record)
  }
}

export { db, insertNotifications }
